import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LOCALES, setLocale } from '../i18n';

/**
 * Reads and changes the app language.
 *
 * Returns `{ locale, setLocale, locales }`. `setLocale` is async because a
 * non-English locale is a lazy chunk — await it if you need the new strings to
 * be live, ignore the promise if you just want the switch to happen.
 */
export default function useLocale() {
  const { i18n } = useTranslation();

  return {
    locale: i18n.resolvedLanguage ?? i18n.language ?? 'en',
    setLocale: useCallback((code) => setLocale(code), []),
    locales: LOCALES.map(({ code, label }) => ({ code, label })),
  };
}
